import type { WebContainer, WebSocketTunnel } from '@webcontainer/api';

export class PreviewTunnel {
  #webcontainer: WebContainer;
  #tunnel: Promise<WebSocketTunnel> | undefined;
  #password: string | undefined;

  constructor(webcontainer: WebContainer) {
    this.#webcontainer = webcontainer;
  }

  async open(id: string) {
    if (this.#tunnel) {
      return;
    }

    if (import.meta.env.VITE_TUNNEL_PASSWORD) {
      this.#password = crypto.randomUUID();
    }

    this.#tunnel = this.#webcontainer.internal.openWebSocketTunnel({
      id,
      tunnelUrl: 'wss://preview.bolt.host',
      password: this.#password,
    });

    await this.#tunnel;
  }

  async close() {
    if (this.#tunnel) {
      const tunnelPromise = this.#tunnel;

      this.#tunnel = undefined;
      this.#password = undefined;

      const tunnel = await tunnelPromise;

      await tunnel.close();
    }
  }

  async getURL(port: number) {
    if (!this.#tunnel) {
      return undefined;
    }

    const tunnel = await this.#tunnel;

    return tunnel.getURL(port);
  }

  getPassword() {
    return this.#password;
  }
}
